import {
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    ConfettiOptions,
} from 'owa-outlook-service-options';
import updateUserConfettiOption from '../data/mutators/updateUserConfettiOption';
import isConfettiEnabled from '../selectors/isConfettiEnabled';
import datapoints from 'owa-confetti-v2/lib/utils/datapoints';
import { logUsage } from 'owa-analytics';

export default async function saveConfettiOption() {
    let userOptions = getOptionsForFeature<ConfettiOptions>(OwsOptionsFeatureType.Confetti);
    let confettiEnabled = isConfettiEnabled();
    updateUserConfettiOption(userOptions, confettiEnabled);
    await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.Confetti,
        userOptions
    );

    if (!confettiEnabled) {
        // Log ConfettiSettingDisabled datapoint
        const { name: eventName } = datapoints.ConfettiSettingDisabled.datapoint;
        logUsage(eventName);
    }
}
